import { chatCompletions, chatCompletionsv2, getChatHistoryListApi } from '../api';
import { resolveHistoryUserContent } from '../utils/historyContent';

// 拉取历史记录并转换为组件可用的 message 结构（未做 Markdown 渲染）
export const fetchChatHistory = async (apiPath = '') => {
    const res = await getChatHistoryListApi(apiPath);
    const response = res?.data || res;
    const history = response?.history;

    if (!Array.isArray(history) || history.length === 0) {
        return [];
    }

    const reversed = [...history].reverse(); // 旧数据在前时反转，让旧消息先渲染

    return reversed.reduce((list, item) => {
        if (!item) return list;
        const id = item.message_id || `${item.timestamp || ''}-${list.length}`;
        const filename = item.filename ?? item.file_name ?? null;
        const fileType = item.file_type ?? item.filetype ?? null;
        const attachmentFilename =
            filename == null || !String(filename).trim() ? null : String(filename).trim();
        const attachmentFileType =
            fileType == null || !String(fileType).trim() ? null : String(fileType).trim();
        const userContent = resolveHistoryUserContent(item);
        if (userContent) {
            list.push({
                id,
                type: 'user',
                content: userContent,
                attachmentFilename,
                attachmentFileType,
            });
        }
        const agentContent =
            item.model_output ??
            item.modelOutput ??
            item.ai_response ??
            item.response ??
            '';
        if (agentContent != null && String(agentContent).trim()) {
            list.push({
                id,
                type: 'agent',
                content: String(agentContent),
                isStreaming: false,
            });
        }
        return list;
    }, []);
};

// 发起聊天流请求，保持与原 chatCompletions 相同的签名
export const startChatCompletion = async (payload, onMessage, onError, onComplete) => {
    return chatCompletionsv2(payload, onMessage, onError, onComplete);
};

